import { encodeResourceName, decodeResourceName, httpInstance, httpGet, httpPost, httpDelete, WsApplication } from 'wsp-core/lib/api';

import { EgApplication, EgApplicationVersion, EgTest, WsSalesProcessInterface } from '../../core/src/interfaces';

import { WsSalesSolutionDeliverableClass, WsSalesSolutionWorkProductClass, WsSalesSolutionOfferingRoleClass, WsSalesSolutionToolClass, WsSalesSolutionRiskClass } from './core-sales';




const sortApplications = (applications: EgApplication[]) => {
  return applications.sort((a: EgApplication, b: EgApplication) => {

    if (a.publisher && b.publisher) {

      if (a.publisher.name === b.publisher.name) {
        if (a.name === b.name) {
          return `${a.currentVersion?.number}` > `${b.currentVersion?.number}` ? 1 : -1;
        } else {
          return a.name > b.name ? 1 : -1;
        }

      } else {
        return a.publisher.name > b.publisher.name ? 1 : -1;
      }

    } else {
      if (a.name === b.name) {
        return `${a.currentVersion?.number}` > `${b.currentVersion?.number}` ? 1 : -1;
      } else {
        return a.name > b.name ? 1 : -1;
      }
    }
  });
};



const sortApplicationVersions = (applicationVersions: EgApplicationVersion[]) => {
  return applicationVersions.sort((a: EgApplicationVersion, b: EgApplicationVersion) => {

    if (a.application.publisher && b.application.publisher) {



      if (a.application.publisher.name === b.application.publisher.name) {
        if (a.application.name === b.application.name) {
          if (a.number === b.number) {
            return `${a.id}` > `${b.id}` ? 1 : -1;
          } else {
            return `${a.number}` > `${b.number}` ? 1 : -1;
          }

        } else {
          return a.application.name > b.application.name ? 1 : -1;
        }

      } else {
        return a.application.publisher.name > b.application.publisher.name ? 1 : -1;
      }



    } else {
      if (a.application.name === b.application.name) {
        if (a.number === b.number) {
          return `${a.id}` > `${b.id}` ? 1 : -1;
        } else {
          return `${a.number}` > `${b.number}` ? 1 : -1;
        }

      } else {
        return a.application.name > b.application.name ? 1 : -1;
      }
    }
  });
};




const sortTests = (tests: EgTest[], desc = false) => {
  return tests.sort((a: EgTest, b: EgTest) => {
    if (desc) {
      return `${a.id}` > `${b.id}` ? -1 : 1;
    } else {
      return `${a.id}` > `${b.id}` ? 1 : -1;
    }
  });
};




export interface WsSelectedActions {
  [key: string]: string | number | undefined;
};







export interface WsSalesScopeMetric {
  name: string;
  value: number;
};


export interface WsSalesScopeItem {
  name: string;
  items?: WsSalesScopeItem[];
  id?: string;
  effort?: number;
  metrics?: WsSalesScopeMetric[];
};


export interface WsSalesCapabilityItem {
  name: string;
  area: string;
  children: WsSalesCapabilityItem[];
  scope?: WsSalesScopeItem[];
};




export interface WsAlert {
  className?: string;
  text: string;
  buttons: {
    ok?:     boolean,
    reload?: boolean
  }
};





export interface WsSalesTeam {
  id: number;
  name: string;
};


export interface WsSalesLocation {
  id: number;
  name: string;
};


export interface WsSolutionCapability {
  path: string;
  isSelected: boolean;
  size: string;
  teamId?: number | undefined;
  locationId?: number | undefined;
  scope?: WsSalesScopeItem[];
};








export interface WsSalesSolutionStaticLookupInterface {
  id: string;
  parentId?: string;
  name: string;
  selected?: boolean;
};







export interface WsSalesSolutionDeliverableInterface {
  id: string;
  parentId?: string;
  name: string;
  description: string;
  format: WsSalesSolutionStaticLookupInterface;
  documentId?: string;
  reviewSettings?: {
    cycles: number;
    review: number;
    update: number;
    approve: number;
  }
};




export interface WsSalesSolutionWorkProductInterface {
  id: string;
  parentId?: string;
  name: string;
  description: string;
  format: WsSalesSolutionStaticLookupInterface;
  documentId?: string;
};








export interface WsSalesSolutionOfferingRoleInterface {
  id: string;
  parentId?: string;
  staticId: string;
  name: string;
  value: number;
  team: string;
  location: string;
  aep: any;
  governance: boolean;
};





export interface WsSalesSolutionToolInterface {
  id: string;
  parentId?: string;
  name?: string;
};



export interface WsSalesSolutionRiskInterface {
  id: string;
  parentId?: string;
  name?: string;
  consequence: string;
  mitigation: string;
  impact: string;
  probability: string;
  owner?: WsSalesSolutionOfferingRoleClass;
  comments: string;
};



export interface WsSalesSolutionDependency {
  id: string;
  parentId?: string;
  name?: string;
  text?: string;

  impact?: string;
  byWhen?: string;
  obligationWith?: string;
};



export interface WsSalesSolutionAssumption {
  id: string;
  parentId?: string;
  name?: string;
  text?: string;

  verification?: string;
  impact?: string;
  owner?: string;
};



export interface WsSalesSolutionMetric {
  id: string;
  parentId?: string;
  name: string;
  effort: number;
  value: number;
  defaultEffort: number;
  defaultValue: number;
  core: boolean;
};



export interface WsSalesSolutionAction {
  scopeCapabilityId?: string;
  parentId?: string;
  id: string;
  name: string;
  description: string;

  effort?: number;
  selected?: boolean;
  expanded?: boolean;

  dependencyIds: string[];

  aepPhase?: string;

  sequential: boolean;
  parallel:   number;

  actions?: WsSalesSolutionAction[];
  metrics?: WsSalesSolutionMetric[];

  dependencies?: WsSalesSolutionDependency[];
  assumptions?:  WsSalesSolutionAssumption[];

  children?: (WsSalesSolutionDeliverableClass | WsSalesSolutionWorkProductClass | WsSalesSolutionOfferingRoleClass | WsSalesSolutionToolClass | WsSalesSolutionRiskClass)[];
};



export interface WsSalesSolutionItem {
  parentId?: string;
  id: string;
  name: string;
  description: string;
  sizeDescription: { [ key: string ]: string };

  areaId?: string;
  selected?: boolean;
  size?: string;
  expanded?: boolean;

  linkIds: string[];

  items?:   WsSalesSolutionItem[];
  actions?: WsSalesSolutionAction[];

  dependencies?: WsSalesSolutionDependency[];
  assumptions?:  WsSalesSolutionAssumption[];

  children?: (WsSalesSolutionDeliverableClass | WsSalesSolutionWorkProductClass | WsSalesSolutionOfferingRoleClass | WsSalesSolutionToolClass | WsSalesSolutionRiskClass)[];
};



export interface WsSalesSolutionArea {
  id: string;
  name: string;
  description: string;
};





















export interface WsSalesUser {
  id: string;
  name: string;
  email: string;
};

export interface WsSalesRole {
  id: string;
  name: string;
  user?: WsSalesUser;
};












export interface WsSalesCountryPerson {
  name: string;
  email: string;
};




export interface WsSalesCountryFields {
  avanade: {
    region: string,
    sponsor: WsSalesCountryPerson,
    sales: WsSalesCountryPerson,
    alliance: WsSalesCountryPerson,
    solutions: WsSalesCountryPerson
  },
  hp: {
    region: '',
    sponsor: WsSalesCountryPerson,
    sales: WsSalesCountryPerson,
    alliance: WsSalesCountryPerson,
    solutions: WsSalesCountryPerson
  }
};




export interface WsSalesClientFields {
};




export interface WsSalesClient {
  id?: number;
  name: string;
  fields?: WsSalesClientFields;
};




export interface WsSalesCountry {
  id?: number
  name: string;
  fields: WsSalesCountryFields;
};








export const DEFAULT_DATE_GRID_STRINGS = {
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  shortDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
};

// export const DEFAULT_DATE_FORMATTING = {
//   formatDay,
//   formatMonth,
//   formatYear,
//   formatMonthDayYear,
//   formatMonthYear,
// };

export const DEFAULT_CALENDAR_STRINGS = {

  ...DEFAULT_DATE_GRID_STRINGS,

  goToToday: 'Go to today',
  weekNumberFormatString: 'Week number {0}',
  prevMonthAriaLabel: 'Previous month',
  nextMonthAriaLabel: 'Next month',
  prevYearAriaLabel: 'Previous year',
  nextYearAriaLabel: 'Next year',
  prevYearRangeAriaLabel: 'Previous year range',
  nextYearRangeAriaLabel: 'Next year range',
  closeButtonAriaLabel: 'Close',
  selectedDateFormatString: 'Selected date {0}',
  todayDateFormatString: "Today's date {0}",
  monthPickerHeaderAriaLabel: '{0}, change year',
  yearPickerHeaderAriaLabel: '{0}, change month',
  dayMarkedAriaLabel: 'marked',
};






export const getSalesClientFieldValue = (salesClient: WsSalesClient, field: string) => {

  if (field === 'name') {
    return salesClient.name;

  } else {

    if (salesClient['fields']) {

      if (salesClient['fields'][field]) {
        return salesClient['fields'][field];

      } else {
        return '';
      }

    } else {
      return '';
    }
  }
};







export const getFieldValue = (salesCountry: WsSalesCountry, org: string, pos: string, field: string) => {

  if (salesCountry['fields']) {

    if (salesCountry['fields'][org]) {

      if (field === 'region') {

        if (salesCountry['fields'][org][field]) {
          return salesCountry['fields'][org][field];

        } else {
          return '';
        }

      } else {

        if (salesCountry['fields'][org][pos]) {

          if (salesCountry['fields'][org][pos][field]) {
            return salesCountry['fields'][org][pos][field];

          } else {
            return '';
          }

        } else {
          return '';
        }

      }

    } else {
      return '';
    }

  } else {
    return '';
  }
};


export const setFieldValue = (salesCountry: WsSalesCountry, org: string, pos: string, field: string, value: string) => {

  if (!salesCountry['fields'][org]) {
    salesCountry['fields'][org] = {};
  }

  if (field === 'region') {

    salesCountry['fields'][org][field] = value;

  } else {

    if (!salesCountry['fields'][org][pos]) {
      salesCountry['fields'][org][pos] = {};
    }
  
    salesCountry['fields'][org][pos][field] = value;

  }

  return salesCountry;
};







export type {
  WsSalesProcessInterface as WsSalesProcess
};

export {
  encodeResourceName,
  decodeResourceName,
  httpDelete,
  httpGet,
  httpInstance,
  httpPost,
  sortApplications,
  sortApplicationVersions,
  sortTests,
  WsApplication
};
